// src/routerConfig.js

import { UserLogin, Monitor, Workplace, Settings } from '@pages';

const routerConfig = [
    {
        path: '/user/login',
        title: '用户登录',
        component: UserLogin,
        authority: true,
    },
    {
        name: '系统设置',
        path: '/sc/settings',
        component: Settings,
    },
    {
        title: '工作台',
        path: '/workplace',
        component: Workplace,
        authority: true,
    },
    {
        title: '数据监控',
        path: '/monitor',
        component: Monitor,
        authority: true,
    },
];

export default routerConfig;
